import './Terms.scss';

import React from 'react';
import PropTypes from 'prop-types';

import connectStore from 'decorators/connectStore';
import provideTranslations from 'decorators/provideTranslations';
import TermsStore from 'stores/TermsStore';
import I18nStore from 'stores/I18nStore';
import IdentityStore from 'stores/IdentityStore';
import TermsActionCreator from 'actions/TermsActionCreator';

import NavPage from 'components/layout/NavPage';
import WorkflowPage from 'components/layout/WorkflowPage';
import BackNavItem from 'components/nav/workflow/BackNavItem';
import ActivitySpinner from 'components/shared/ActivitySpinner';

@connectStore(TermsStore, 'termsState')
@provideTranslations('Core')
class TermsContainer extends React.Component {
  render() {
    return (
      <Terms {...this.props} />
    );
  }
}

class Terms extends React.Component {
  static propTypes = {
    backHandler: PropTypes.func,
    termsState: PropTypes.object.isRequired,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (!this.props.termsState.terms) {
      TermsActionCreator.bootstrapLegalData();
      TermsActionCreator.fetchTerms({ locale: I18nStore.getState().currentLocale });
    }
  }

  renderTermsContent() {
    return (
      // Do not pass in user input because of XSS risks with dangerouslySetInnerHTML
      this.props.termsState.terms
        ? <div className="terms-content" dangerouslySetInnerHTML={{ __html: this.props.termsState.terms }} />
        : <ActivitySpinner isActive />
    );
  }

  renderNavPageTerms() {
    const { getString } = this.context;

    return (
      <NavPage>
        <div className="aa-nav-terms-container">
          <h3>{getString('AA_Terms_And_Conditions')}</h3>
          {this.renderTermsContent()}
        </div>
      </NavPage>
    );
  }

  renderBackLink() {
    const { getString } = this.context;

    return (
      <a onClick={this.props.backHandler} className="back-link pull-right hidden-xs">
        {getString('AA_Back')}
      </a>
    );
  }

  renderWorkflowPageTerms() {
    const { getString } = this.context;

    const leftNav = this.props.backHandler
      ? <BackNavItem backHandler={this.props.backHandler} /> : null;
    return (
      <WorkflowPage
        leftNav={leftNav}
        backgroundClassName="bg-grey"
      >
        <div className="aa-workflow-terms-container">
          <h3 className="workflow-terms-heading hidden-xs">
            {getString('AA_Terms_And_Conditions')}
          </h3>
          {this.renderTermsContent()}
          {this.props.backHandler ? this.renderBackLink : null}
        </div>
      </WorkflowPage>
    );
  }

  render() {
    let termsPage;

    if (this.props.backHandler || !IdentityStore.getState().currentIdentity) {
      termsPage = this.renderWorkflowPageTerms();
    } else {
      termsPage = this.renderNavPageTerms();
    }

    return termsPage;
  }
}

export default TermsContainer;
